import { render } from "./PostHeader.vue?vue&type=template&id=61ce6a62"
import script from "./PostHeader.vue?vue&type=script&lang=js"
export * from "./PostHeader.vue?vue&type=script&lang=js"
script.render = render

export default script